import { Badge, type BadgeProps, badgeClasses } from '@mui/material';
import type { FC } from 'react';

type Props = Omit<BadgeProps, 'sx'> & {
  textColor?: string;
  backgroundColor?: string;
};

export const SquaredBadge: FC<Props> = ({
  textColor = 'SlabGray.0',
  backgroundColor = 'SlabIndigo.500',
  children,
  ...rest
}) => {
  return (
    <Badge
      {...rest}
      sx={{
        '& .MuiBadge-badge': {
          backgroundColor,
          color: textColor,
          position: 'relative',
          transform: 'none',
          fontSize: '14px',
          minWidth: '26px',
          boxSizing: 'content-box',
          p: 0.5,
          height: '18px',
          borderRadius: '0.5rem',
          [`&.${badgeClasses.invisible}`]: { display: 'none' },
        },
      }}
    >
      {children}
    </Badge>
  );
};
